module.exports = __webpack_public_path__ + "media/icons/duplicate-b98b6641.svg";